import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TPriceListDM from './TPriceListDM'

/**
 * Ceníky - nadřízené
 */
export default class TPriceListSuperiorDM extends Data {
	public static className = 'TPriceListSuperiorDM'
	public static primaryKey = 'SequenceNumber'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.SequenceNumber!
	}

	public static isHeader = false

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Pořadí
	 */
	RecordNo?: number

	/**
	 * undefined
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * undefined
	 */
	Level?: number

	/**
	 * undefined
	 */
	SequenceNumber?: number

	/**
	 * undefined
	 */
	HeaderRID?: number

	/**
	 * undefined
	 */
	IsPriceSource?: string

	/**
	 * undefined
	 */
	IsArticleSource?: string

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * undefined
	 */
	@Type(() => TPriceListDM)
	PriceListRID?: TPriceListDM
}